import { escapeHtml } from "@emkit/builder-core";
export const ICON_LIST_DEFAULTS = {
    items: [
        { id: "i1", icon: "✓", text: "Ships clean static HTML" },
        { id: "i2", icon: "✓", text: "Zero-runtime for most widgets" },
        { id: "i3", icon: "✓", text: "Responsive by default" },
    ],
    layout: "vertical",
    size: "md",
    iconColor: "#ffffff",
    badgeColor: "#111827",
    textColor: "#111827",
};
const SIZES = {
    sm: { badge: 20, glyph: 12, text: 14, gap: 10, rowGap: 8 },
    md: { badge: 28, glyph: 14, text: 16, gap: 12, rowGap: 12 },
    lg: { badge: 36, glyph: 18, text: 18, gap: 14, rowGap: 16 },
};
export const iconListWidget = {
    type: "icon-list",
    defaultProps: ICON_LIST_DEFAULTS,
    renderHtml(props) {
        const items = props.items ?? [];
        if (items.length === 0) {
            return `<div class="emk-icon-list" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty list — add items in the inspector)</div>`;
        }
        const layout = props.layout ?? "vertical";
        const size = SIZES[props.size ?? "md"];
        const iconColor = props.iconColor ?? "#ffffff";
        const badgeColor = props.badgeColor ?? "";
        const textColor = props.textColor ?? "#111827";
        const wrapStyle = [
            layout === "horizontal"
                ? "display:flex;flex-wrap:wrap;align-items:center"
                : "display:flex;flex-direction:column;align-items:flex-start",
            layout === "horizontal" ? `gap:${size.rowGap + 4}px` : `gap:${size.rowGap}px`,
            "font-family:inherit",
            "list-style:none",
            "margin:0",
            "padding:0",
        ].join(";");
        const itemStyle = [
            "display:flex",
            "align-items:center",
            `gap:${size.gap}px`,
            `font-size:${size.text}px`,
            "line-height:1.5",
            `color:${textColor}`,
        ].join(";");
        const badgeStyle = [
            "display:inline-flex",
            "align-items:center",
            "justify-content:center",
            "flex-shrink:0",
            `width:${size.badge}px`,
            `height:${size.badge}px`,
            `font-size:${size.glyph}px`,
            "border-radius:50%",
            `color:${iconColor}`,
            badgeColor ? `background:${badgeColor}` : "background:transparent",
            "font-weight:600",
        ].join(";");
        const rows = items
            .map((it) => `<li style="${itemStyle}"><span class="emk-icon-list-badge" aria-hidden="true" style="${badgeStyle}">${escapeHtml(it.icon)}</span><span>${escapeHtml(it.text)}</span></li>`)
            .join("");
        return `<ul class="emk-icon-list" style="${wrapStyle}">${rows}</ul>`;
    },
};
//# sourceMappingURL=icon-list.js.map